var React = require('react');

function I (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0C4.47596 0 0 4.47596 0 10C0 15.524 4.47596 20 10 20C15.524 20 20 15.524 20 10C20 4.47596 15.524 0 10 0ZM9.78365 5C10.3173 5 10.7452 5.43269 10.7452 5.96154C10.7452 6.49038 10.3125 6.92308 9.78365 6.92308C9.25481 6.92308 8.82212 6.49038 8.82212 5.96154C8.82212 5.43269 9.25 5 9.78365 5ZM11.5385 14.6154H8.46154V14.2308H9.23077V8.46154H8.46154V8.07692H10.7692V14.2308H11.5385V14.6154Z"}));
}

I.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"black"};

module.exports = I;

I.default = I;
